module.exports = __webpack_public_path__ + "static/media/dele.c27140c8.m4a";